import { useEffect, useState } from "react";
import { Radio } from "lucide-react";
import client from "@/lib/api";

export default function LiveButton() {
  const [live, setLive] = useState({ active: false, url: "", label: "" });

  useEffect(() => {
    const load = () => client.get("/settings/live").then((r) => setLive(r.data || {})).catch((e) => console.error("Live status failed:", e));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!live.active || !live.url) return null;

  return (
    <a
      href={live.url}
      target="_blank"
      rel="noreferrer"
      data-testid="live-button"
      className="fixed right-4 bottom-24 md:bottom-6 z-[65] inline-flex items-center gap-2 bg-legend-red text-white font-display font-black uppercase tracking-wide text-sm px-5 py-3 rounded-full shadow-2xl border-2 border-white animate-pulse hover:animate-none hover:scale-105 transition"
    >
      <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
      </span>
      <Radio size={16} /> {live.label || "🔴 Segui la diretta / Live Timing"}
    </a>
  );
}
